var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.344 25.299h4.102v-10.22h3.43l.518-3.976h-3.948V8.555c0-1.148.322-1.932 1.974-1.932h2.114v-3.57a30.2 30.2 0 00-3.066-.154c-3.052 0-5.124 1.862-5.124 5.264v2.94H8.9v3.976h3.444v10.22z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyOSAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjM0MzkgMjUuMjk4OUgxNi40NDU5VjE1LjA3ODlIMTkuODc1OUwyMC4zOTM5IDExLjEwMjlIMTYuNDQ1OVY4LjU1NDkyQzE2LjQ0NTkgNy40MDY5MyAxNi43Njc5IDYuNjIyOTMgMTguNDE5OSA2LjYyMjkzSDIwLjUzMzlWMy4wNTI5M0MyMC4xNjk5IDMuMDEwOTMgMTguOTIzOSAyLjg5ODkzIDE3LjQ2NzkgMi44OTg5M0MxNC40MTU5IDIuODk4OTMgMTIuMzQzOSA0Ljc2MDkzIDEyLjM0MzkgOC4xNjI5M1YxMS4xMDI5SDguODk5OVYxNS4wNzg5SDEyLjM0MzlWMjUuMjk4OVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgFacebook as ReactComponent };